import { Button } from '@mui/material';

import { useQuestionInfoMutation } from '@/hooks/useQuestionInfoMutation';
import { useTranslate } from '@/hooks/useTranslate';

import { getDataTestId } from '@/utils/browser';

import { ActionBar } from '../../../../Layout';
import { QuestionProps } from './QuestionDrawer.interface';
import { QuestionForm } from './QuestionForm';

import { USIndiciaImage } from './QuestionDrawer.styled';

export function QuestionAboutUSIndicia({
  onAnswered,
  ...props
}: QuestionProps) {
  const { t } = useTranslate();
  const { mutate, isPending, error } = useQuestionInfoMutation({
    onFinished: onAnswered,
    target: props.pepAnswerTarget,
  });

  const onAnswer = (value: boolean) => {
    mutate({
      usIndicia: value,
    });
  };

  return (
    <QuestionForm
      {...props}
      image={<USIndiciaImage />}
      isLoading={isPending}
      answerError={error}
    >
      <ActionBar>
        <Button
          {...getDataTestId(`basic-info-yes-button`)}
          variant="outlined"
          fullWidth
          onClick={() => onAnswer(true)}
          disabled={isPending}
        >
          {t('questionDrawer.USIndicia.button.yes')}
        </Button>
        <Button
          {...getDataTestId(`basic-info-no-button`)}
          variant="outlined"
          fullWidth
          onClick={() => onAnswer(false)}
          disabled={isPending}
        >
          {t('questionDrawer.USIndicia.button.no')}
        </Button>
      </ActionBar>
    </QuestionForm>
  );
}
